// Applique la forme (rayon d'arrondi / ombre) de la boutique (Studio de
// thème) en custom properties CSS sur :root — tailwind.config.js lit ces
// mêmes variables (rounded-btn/rounded-card/rounded-media/shadow-card) avec
// un repli identique au rendu d'origine (rounded-xl/rounded-2xl/shadow-xl)
// tant qu'elles ne sont pas définies, exactement comme applyPalette.js/
// applyTypography.js. `shape` est la réponse DÉJÀ RÉSOLUE du backend
// (get_theme_shape : {shape, resolved, options}) — jamais recalculée ici.
export default function applyShape(shape) {
  const resolved = shape?.resolved;
  if (!resolved) return;
  const root = document.documentElement;
  if (resolved.btn) root.style.setProperty("--radius-btn", resolved.btn);
  if (resolved.card) root.style.setProperty("--radius-card", resolved.card);
  if (resolved.media) root.style.setProperty("--radius-media", resolved.media);
  if (resolved.shadow_card) root.style.setProperty("--shadow-card", resolved.shadow_card);
}
